import { useStore } from "zustand"
import { useShallow } from "zustand/react/shallow"
import { isFunction, isString } from "@repo/utils"

export default function useCustomStore(store, selector) {
	if (isFunction(selector)) {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		return useStore(
			store,
			// eslint-disable-next-line react-hooks/rules-of-hooks
			useShallow((state) => selector(state.store)),
		)
	}

	if (isString(selector)) {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		return useStore(
			store,
			// eslint-disable-next-line react-hooks/rules-of-hooks
			useShallow((state) => state.store[selector]),
		)
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	return useStore(store, (state) => state.store)
}
